export default __webpack_public_path__ + "static/media/Product.66bd347b.svg";